import React from "react";
import LargeHeaderTitle from "../components/LargeHeaderTitle";

const ReturnPolicy = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] py-12 px-4">
      <LargeHeaderTitle title="Return " highlight="Policy" />
      <div className="max-w-2xl text-center mt-8 text-lg text-slate-200">
        <p className="mb-4">
          Due to the digital and intellectual property nature of our software, <strong>all sales are final</strong> and <strong>no refunds will be issued</strong> under any circumstances.
        </p>
        <p>
          Please ensure you fully understand the product and its capabilities before making a purchase. If you have any questions, contact us prior to checkout.
        </p>
      </div>
    </div>
  );
};

export default ReturnPolicy;
